import React from 'react'
import { Section, SectionHeader, SectionRow } from '../../styles'
import IconHelper from '@ringdna/common/src/assets/icons/IconHelper'
import RdnaText from '@ringdna/common/src/components/RdnaText'
import SettingsToggle from '../SettingsToggleSwitch'
import { TabProps } from '../../types'
import ComplianceAnnouncementsTable from './ComplianceAnnouncementsTable'
import { complianceAnnouncementsSettings } from '../../const'
import ComplianceAnnouncementIcon from '@ringdna/common/src/assets/icons/svg/ComplianceAnnouncement'
import { HEADER_TEXT } from './const'
import { useUser } from '../../../common/services/UserContext'

export default function ComplianceAnnouncements({ accountId, accountSettings, setAccountSettings }: TabProps) {
  const { isAuthorizedAdmin, licenses, accountId: userAccountId } = useUser()
  const isSettingAllowed = isAuthorizedAdmin || userAccountId.toString() == accountId.toString()
  const isEditingAllowed = (licenses.support || licenses.admin) && isSettingAllowed
  return (
    <>
      <Section>
        <SectionRow>
          <SectionHeader>
            <IconHelper icon={ComplianceAnnouncementIcon} variant="filled" />
            <RdnaText className={'rdna-text'}>{HEADER_TEXT}</RdnaText>
          </SectionHeader>
          <SettingsToggle
            isChecked={accountSettings[complianceAnnouncementsSettings]}
            setting={complianceAnnouncementsSettings}
            accountSettings={accountSettings}
            setAccountSettings={setAccountSettings}
            disabled={!(licenses.admin && isSettingAllowed)}
          />
        </SectionRow>
      </Section>
      {accountSettings[complianceAnnouncementsSettings] && (
        <ComplianceAnnouncementsTable accountId={accountId} isEditingAllowed={isEditingAllowed} />
      )}
    </>
  )
}
